module.exports = __webpack_public_path__ + "img/ic_share_wa.7e046890.svg";